import React, { useState } from 'react';
import './AssetIcon.css';

// 使用专业的加密货币图标库 cryptocurrency-icons
// 资产名称到图标文件名的映射
const assetIconMap = {
  'usdt': 'usdt',
  'eth': 'eth',
  'btc': 'btc',
  'atom': 'atom',
  'xlm': 'xlm',
  'aster': 'generic', // 如果没有对应图标，使用通用图标
  'santos': 'generic',
  'bnb': 'bnb',
};

// 获取图标路径（使用 process.env.PUBLIC_URL 或相对路径）
const getIconPath = (assetName) => {
  const name = assetName.toLowerCase();
  const iconName = assetIconMap[name] || 'generic';
  // 使用 public 目录下的图标，或者直接从 node_modules 引用
  // 由于 create-react-app 的限制，我们需要将图标复制到 public 目录
  // 或者使用 CDN
  return `/crypto-icons/${iconName}.svg`;
};

// 使用 CDN 作为备用方案
const getCdnIconPath = (assetName) => {
  const name = assetName.toLowerCase();
  const iconName = assetIconMap[name] || 'generic';
  // 使用 jsDelivr CDN
  return `https://cdn.jsdelivr.net/npm/cryptocurrency-icons@0.18.1/svg/color/${iconName}.svg`;
};

const AssetIcon = ({ assetName, size = 24, className = '' }) => {
  const [iconError, setIconError] = useState(false);
  const name = assetName.toLowerCase();
  const iconName = assetIconMap[name] || 'generic';
  
  // 优先使用 CDN（更可靠）
  const iconSrc = getCdnIconPath(assetName);
  
  // 如果图标加载失败，显示备用图标
  const fallbackIcon = getFallbackIcon(name);
  
  if (iconError) {
    return (
      <div 
        className={`asset-icon-wrapper asset-icon-fallback ${className}`} 
        style={{ width: size, height: size }}
      >
        {fallbackIcon}
      </div>
    );
  }
  
  return (
    <div className={`asset-icon-wrapper ${className}`} style={{ width: size, height: size }}>
      <img
        src={iconSrc}
        alt={assetName}
        className="asset-icon-img"
        style={{ width: size, height: size }}
        onError={() => setIconError(true)}
      />
    </div>
  );
};

// 备用图标（使用 react-icons）
const getFallbackIcon = (name) => {
  // 使用简单的文字或符号作为备用
  const icons = {
    'usdt': 'USDT',
    'eth': 'Ξ',
    'atom': 'ATOM',
    'xlm': 'XLM',
    'aster': 'ASTER',
    'santos': 'SANTOS',
  };
  return icons[name] || '?';
};

export default AssetIcon;

